import "swiper/css";

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const swipers = () => {
  const sections = document.querySelectorAll(".il-swiper");

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    const swiperContainer = section.querySelector(".swiper");
    const nextButton = section.querySelector(".swiper-next");
    const prevButton = section.querySelector(".swiper-prev");
    const paginationElement = section.querySelector(".swiper-pagination");

    if (!swiperContainer) {
      return;
    }

    new Swiper(swiperContainer, {
      modules: [Navigation, Pagination],

      slidesPerView: 3,
      centeredSlides: true,
      initialSlide: 1,
      loop: false,
      spaceBetween: 10,

      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },

      ...(paginationElement
        ? {
            pagination: {
              el: paginationElement,
              clickable: true,
            },
          }
        : {}),
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },

        768: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },

        1024: {
          slidesPerView: 2.6,
          spaceBetween: 20,
        },


        1200: {
          slidesPerView: 3,
          spaceBetween: 10,
        }

      },
    });
  });
}

const sliders = () => {
  const sections = document.querySelectorAll(".il-slider");

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    const sliderContainer = section.querySelector(".slider");
    const nextButton = section.querySelector(".slider-next");
    const prevButton = section.querySelector(".slider-prev");
    const paginationElement = section.querySelector(".slider-pagination");

    if (!sliderContainer) {
      return;
    }

    new Swiper(sliderContainer, {
      modules: [Navigation, Pagination],

      slidesPerView: 6,
      centeredSlides: false,
      initialSlide: 1,
      loop: false,
      spaceBetween: 20,
      preventClicks: false,
      preventClicksPropagation: false,
      touchStartPreventDefault: false,

      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },

      ...(paginationElement
        ? {
            pagination: {
              el: paginationElement,
              clickable: true,
            },
          }
        : {}),
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },

        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },

        1024: {
          slidesPerView: 2,
          spaceBetween: 20,
        },

        1200: {
          slidesPerView: 6,
          spaceBetween: 30,
        }

      },
    });
  });
}

const team = () => {
  const teamSections = document.querySelectorAll(".il-team");

  if (!teamSections.length) {
    return;
  }

  teamSections.forEach((section) => {
    const sliderContainer = section.querySelector(".il-team__slider");
    const paginationElement = section.querySelector(".il-team__pagination");

    if (!sliderContainer || !paginationElement) {
      return;
    }

    new Swiper(sliderContainer, {
      modules: [Pagination],
      slidesPerView: 4,
      centeredSlides: false,
      loop: false,
      spaceBetween: 80,
      pagination: {
        el: paginationElement,
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  });
}

swipers();
sliders();
team();